export default "__VITE_ASSET__Lp7HSoDH__"